import React from 'react';
import { Spin } from "antd";

export default function () {
    return <div style={ {
        width: "100%",
        height: "100%",
        display: "flex",
        paddingTop: "100px",
        justifyContent: "center",
    } }><Spin/></div>
}

